import React from "react";

const AccountQA = ({
  personalInfo,
  formValue,
  setFormValue,
  debounceUpdatePersonalDataField,
}) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    const index = formValue.findIndex((item) => item.question === name);
    if (index !== -1) {
      const updatedFormValue = [...formValue];
      updatedFormValue[index] = { question: name, answer: value };
      setFormValue(updatedFormValue);
      debounceUpdatePersonalDataField(
        "depositry_charge_questions",
        updatedFormValue
      );
    } else {
      const updatedFormValue = [
        ...formValue,
        { question: name, answer: value },
      ];
      setFormValue(updatedFormValue);
      debounceUpdatePersonalDataField(
        "depositry_charge_questions",
        updatedFormValue
      );
    }
  };

  return (
    <div>
      <h5>Type of Account (for Individual account)</h5>
      <div className="row mt-3">
        <div className="col-md-9">
          I/We instruct the DP to receive each and every credit in my/our
          account.
        </div>
        <div className="col-md-3">
          <div className="form-check form-check-inline">
            <input
              name="1"
              className="form-check-input"
              type="radio"
              value="Yes"
              checked={
                formValue.find((item) => item.question === "1")?.answer ===
                "Yes"
              }
              onChange={(e) => handleChange(e)}
            />
            <label className="form-check-label">Yes</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              name="1"
              type="radio"
              value="No"
              checked={
                formValue.find((item) => item.question === "1")?.answer === "No"
              }
              onChange={(e) => handleChange(e)}
            />
            <label className="form-check-label">No</label>
          </div>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-md-9">
          I/We would like to instruct the DP to accept all the pledge
          instructions in my/our account without any further instructions on
          my/our end.
        </div>
        <div className="col-md-3">
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              name="2"
              type="radio"
              value="Yes"
              checked={
                formValue.find((item) => item.question === "2")?.answer ===
                "Yes"
              }
              onChange={(e) => handleChange(e)}
            />
            <label className="form-check-label">Yes</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              name="2"
              type="radio"
              value="No"
              checked={
                formValue.find((item) => item.question === "2")?.answer === "No"
              }
              onChange={(e) => handleChange(e)}
            />
            <label className="form-check-label">No</label>
          </div>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-md-12">Account Statement requirement:</div>
        <div className="col-md-12">
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              name="3"
              type="radio"
              value="As per SEBI Regulation"
              checked={
                formValue.find((item) => item.question === "3")?.answer ===
                "As per SEBI Regulation"
              }
              onChange={(e) => handleChange(e)}
            />
            <label className="form-check-label">As per SEBI Regulation</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              name="3"
              type="radio"
              value="Daily"
              checked={
                formValue.find((item) => item.question === "3")?.answer ===
                "Daily"
              }
              onChange={(e) => handleChange(e)}
            />
            <label className="form-check-label">Daily</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              name="3"
              type="radio"
              value="Weekly"
              checked={
                formValue.find((item) => item.question === "3")?.answer ===
                "Weekly"
              }
              onChange={(e) => handleChange(e)}
            />
            <label className="form-check-label">Weekly</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              name="3"
              type="radio"
              value="Fortnightly"
              checked={
                formValue.find((item) => item.question === "3")?.answer ===
                "Fortnightly"
              }
              onChange={(e) => handleChange(e)}
            />
            <label className="form-check-label">Fortnightly</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              name="3"
              type="radio"
              value="Monthly"
              checked={
                formValue.find((item) => item.question === "3")?.answer ===
                "Monthly"
              }
              onChange={(e) => handleChange(e)}
            />
            <label className="form-check-label">Monthly</label>
          </div>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-md-9">
          I/We request you to send Electronic Transaction - cum - Holding
          Statement at the E-Mail ID{" "}
          <input
            name="email"
            type="text"
            placeholder="Email Address"
            style={{
              border: 0,
              borderBottom: "1px solid #000",
              marginLeft: 10,
              width: "40%",
            }}
            value={personalInfo?.email}
            disabled
          />
        </div>
        <div className="col-md-3">
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              name="4"
              type="radio"
              value="Yes"
              checked={
                formValue.find((item) => item.question === "4")?.answer ===
                "Yes"
              }
              onChange={(e) => handleChange(e)}
            />
            <label className="form-check-label">Yes</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              name="4"
              type="radio"
              value="No"
              checked={
                formValue.find((item) => item.question === "4")?.answer === "No"
              }
              onChange={(e) => handleChange(e)}
            />
            <label className="form-check-label">No</label>
          </div>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-md-9">
          I/We would like to share the email ID with the RTA.
        </div>
        <div className="col-md-3">
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              name="5"
              type="radio"
              value="Yes"
              checked={
                formValue.find((item) => item.question === "5")?.answer ===
                "Yes"
              }
              onChange={(e) => handleChange(e)}
            />
            <label className="form-check-label">Yes</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              name="5"
              type="radio"
              value="No"
              checked={
                formValue.find((item) => item.question === "5")?.answer === "No"
              }
              onChange={(e) => handleChange(e)}
            />
            <label className="form-check-label">No</label>
          </div>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-md-12">
          I/We would like to receive the Annual Report.
        </div>
        <div className="col-md-12">
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              name="6"
              type="radio"
              value="Physical"
              checked={
                formValue.find((item) => item.question === "6")?.answer ===
                "Physical"
              }
              onChange={(e) => handleChange(e)}
            />
            <label className="form-check-label">Physical</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              name="6"
              type="radio"
              value="Electronic"
              checked={
                formValue.find((item) => item.question === "6")?.answer ===
                "Electronic"
              }
              onChange={(e) => handleChange(e)}
            />
            <label className="form-check-label">Electronic</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              name="6"
              type="radio"
              value="Both Physical and Electronic"
              checked={
                formValue.find((item) => item.question === "6")?.answer ===
                "Both Physical and Electronic"
              }
              onChange={(e) => handleChange(e)}
            />
            <label className="form-check-label">
              Both Physical and Electronic
            </label>
          </div>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-md-9">
          Do you wish to receive dividend/interest directly in to your bank
          account given through ECS?
        </div>
        <div className="col-md-3">
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              name="7"
              type="radio"
              value="Yes"
              checked={
                formValue.find((item) => item.question === "7")?.answer ===
                "Yes"
              }
              onChange={(e) => handleChange(e)}
            />
            <label className="form-check-label">Yes</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              name="7"
              type="radio"
              value="No"
              checked={
                formValue.find((item) => item.question === "7")?.answer === "No"
              }
              onChange={(e) => handleChange(e)}
            />
            <label className="form-check-label">No</label>
          </div>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-md-9">
          SMS alert Facility
          <input
            name="mobile"
            type="text"
            placeholder="Mobile Number"
            style={{
              border: 0,
              borderBottom: "1px solid #000",
              marginLeft: 10,
              width: "40%",
            }}
            value={personalInfo?.phone}
            disabled
          />
        </div>
        <div className="col-md-3">
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              name="8"
              type="radio"
              value="Yes"
              checked={
                formValue.find((item) => item.question === "8")?.answer ===
                "Yes"
              }
              onChange={(e) => handleChange(e)}
            />
            <label className="form-check-label">Yes</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              name="8"
              type="radio"
              value="No"
              checked={
                formValue.find((item) => item.question === "8")?.answer === "No"
              }
              onChange={(e) => handleChange(e)}
            />
            <label className="form-check-label">No</label>
          </div>
        </div>
      </div>

      <div
        style={{
          border: "1px solid #e7e7e7",
          padding: "0px 10px",
          margin: "15px 0",
          paddingBottom: "15px",
        }}
      >
        <div className="row mt-3">
          <strong>Transaction using secured Texting facility (TRUST)</strong>
        </div>
        <div className="row mt-3">
          <div className="col-md-12">
            I wish to avail he TRUST facility using the Mobile number registered
            for SMS Alert Facility. I have read and understood the Terms and
            Conditions prescribed by CSDL for the same
          </div>
          <div className="col-md-3">
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                name="9"
                type="radio"
                value="Yes"
                checked={
                  formValue.find((item) => item.question === "9")?.answer ===
                  "Yes"
                }
                onChange={(e) => handleChange(e)}
              />
              <label className="form-check-label">Yes</label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                name="9"
                type="radio"
                value="No"
                checked={
                  formValue.find((item) => item.question === "9")?.answer ===
                  "No"
                }
                onChange={(e) => handleChange(e)}
              />
              <label className="form-check-label">No</label>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-9">
            I/We Wish to register the following clearing member IDs under My/our
            below mentioned BO ID registered for TURST
          </div>
          <div className="col-md-12 mt-2">
            <table className="table">
              <thead>
                <tr>
                  <th>Stock Exchange Name/Id</th>
                  <th>Clearing Member Name</th>
                  <th>Clearing Member Id</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input
                      name="clearingMemberName"
                      type="text"
                      placeholder=""
                      style={{
                        border: 0,
                        borderBottom: "1px solid #000",
                        width: "100%",
                      }}
                      value={"NSE"}
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      name="clearingMemberId"
                      type="text"
                      placeholder=""
                      style={{
                        border: 0,
                        borderBottom: "1px solid #000",
                        width: "100%",
                      }}
                      value={"Vachana Investments Pvt Ltd"}
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      name="stockExchangeName"
                      type="text"
                      placeholder=""
                      style={{
                        border: 0,
                        borderBottom: "1px solid #000",
                        width: "100%",
                      }}
                      value={"90005"}
                      disabled
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-md-9">
          <strong>BSDA:</strong> I/We wish to avail the BSDA facility, if
          selected 'No' the demat account will be treated as normal demat
          account unlil and unless the BO requests for conversion to BSDA.
        </div>
        <div className="col-md-3">
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              name="10"
              type="radio"
              value="Yes"
              checked={
                formValue.find((item) => item.question === "10")?.answer ===
                "Yes"
              }
              onChange={(e) => handleChange(e)}
            />
            <label className="form-check-label">Yes</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              name="10"
              className="form-check-input"
              type="radio"
              value="No"
              onChange={(e) => handleChange(e)}
              checked={
                formValue.find((item) => item.question === "10")?.answer ===
                "No"
              }
            />
            <label className="form-check-label">No</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              name="10"
              className="form-check-input"
              type="radio"
              value="Opted Out"
              onChange={(e) => handleChange(e)}
              checked={
                formValue.find((item) => item.question === "10")?.answer ===
                "Opted Out"
              }
            />
            <label className="form-check-label">Opted Out</label>
          </div>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-md-9">
          <strong>Easi:</strong> To register for easi, please visit CDSL
          website:{" "}
          <a
            href="https://www.cdslindia.com"
            target="_blank"
            rel="noreferrer"
          >
            www.cdslindia.com.{" "}
          </a>
          Easi allows you to view your ISIN balances, transactions and value of
          the portfolio online.
        </div>
        <div className="col-md-3">
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              name="11"
              type="radio"
              value="Yes"
              checked={
                formValue.find((item) => item.question === "11")?.answer ===
                "Yes"
              }
              onChange={(e) => handleChange(e)}
            />
            <label className="form-check-label">Yes</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              name="11"
              type="radio"
              value="No"
              checked={
                formValue.find((item) => item.question === "11")?.answer ===
                "No"
              }
              onChange={(e) => handleChange(e)}
            />
            <label className="form-check-label">No</label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountQA;
